import { Col, Form, Input, Modal, ModalProps, Row } from 'antd';
import { FloatingFormItem } from '@/components/_common';
import { useUserPasswordRecovery } from '@/core/domain/enterprise/Users/Users.hooks';
import { useDefaultEmptyFieldError } from '@/hooks';

interface Props extends ModalProps {
  onCancel: () => void;
}

const ForgotPasswordModal = ({ open, onCancel }: Props) => {
  const [form] = Form.useForm<{ login: string; email: string }>();
  const passwordRecovery = useUserPasswordRecovery();
  const ruleRequired = useDefaultEmptyFieldError();

  const handleOk = async () => {
    try {
      const values = await form.validateFields();

      await passwordRecovery.mutateAsync(values);

      handleClose();
    } catch {}
  };

  function handleClose() {
    form.resetFields();
    onCancel();
  }

  return (
    <Modal
      title="Esqueci minha senha"
      open={open}
      onCancel={handleClose}
      onOk={handleOk}
      confirmLoading={passwordRecovery.isLoading}
    >
      <Form form={form}>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <FloatingFormItem name="login" label="Login" rules={[ruleRequired]}>
              <Input />
            </FloatingFormItem>
          </Col>

          <Col span={24}>
            <FloatingFormItem
              name="email"
              label="E-mail"
              rules={[ruleRequired]}
            >
              <Input />
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default ForgotPasswordModal;
